export default __webpack_public_path__ + "a9dbc40c1e1be9fb5dc64bc1be977a30.png";